
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')

let initStore = {
    loading: false,
    error: false,
    /*sva*/
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    /*svae */
    my_data: [],
    loadingRESERVATION:false,
    errorRESERVATION:false,
    my_data_traveller:{
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "disdcode": "33",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    custProfile: {
        "customerId": 6,
        "addressId":-1
    },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    sj_data_dtoken:{
        "email": "suelb22@yahoo.com",
        "subject": "Reservation Details",
        "customerId": "-131",
        "status": "OK",
        "digitalCode": "111111"
    },
    sj_data_card:{
        "id": "-4",
        "cardId": "-4",
    
       
        "card": "7777-1234--1234--1234",
        "cvv": "777",
        "mmexp": "07",
        "yyyyexp": "77",
        "otherDetails" :"Default facility",
        "specialRequests": "Default chair and Senior Citizen",
        "privateparking":false,
            "rentcar":false,
            "bookTaxi":false,
            "needFlight":false,
            "arrivalTimeZone":"tz_pst"
      
        
    
      },

    sj_data_address: {
        "id": 6,
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "95123",
        "zipcode": "95123",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    },
    my_data_review:{
        "Request": {
            "checkin": "OK",
            "stay": "6",
            "stayInit": "nights",
            "checkout": "UU12345",
            "checkinTime": "Sat, Sept 9, 3027",
            "checkinTimePrefix": "From 3:00 PM",
            "checkoutTimePrefix": "Until 11:00 AM",
            "checkoutTime": "Sat, Sept 16, 3027"
        },
        "spaceDet": {
        
            "space_details": "Queen Room with Two Queen Beds",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "cancellation": "Free cancellation before December 9, 2024 ",
            "guests": "2 adults ",
            "cleaniness_score" : "7.7",
            "non_smoking":true,
    
            "space_amenity_name": [
                "300 feet elevator",
                "air conditioning",
                "private bathroom"
            ]
           
           
        },
        "booking": {
            "resort_name": "Cambria Hotel Orlando Airport",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "stayDet": "6 nights",
            "num_reviews": 101,
            "amenity_name": [
                "HotTub",
                "Spa",
                "Swimming pool",
                "Laundry"
            ],
            "num_reviews_label": "Good, ",
            "rating_detail":" Excellebt, 9.1",
            "num_reviews_detail": "Good, 101 reviews"
           
        },
        "price": {
            "total": "$923",
            "depositValue":"$200.26",
            "depositName":"Damage Deposit (Fully refundable)",
            "currency": "usd",
            "tax": {
               
                "taxTotal": "$102.34",
                "maintax": "$49.08",
                "citytax": "$53.26",
    
                "taxPercent": "6",
                "citytaxPercent": "6.5"
            }
        },
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    my_data_price_confirmation:{

        "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
    },
    svr_soj_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    
    sojourns:[]
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState, svns;
    switch (action.type) {
        case "book/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case 'GET_SJPRICEANDTAX_SUCCESS':
            console.log("reduce %%%%%%%%GET_SJPRICEANDTAX_SUCCESS  success*****************");
            console.log(action.payload.my_data_price_confirmation);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            /*sva
            
            januState = {...state, loadingRESERVATION: false, my_data_price_confirmation: action.payload.my_data_price_confirmation}
            */
            januState = {...state, loadingRESERVATION: false,errorRESERVATION: false, errob:null,crudsuccessob:null, my_data_price_confirmation: action.payload.my_data_price_confirmation}
            
            return januState

        case 'GET_SJPRICEANDTAX_BEGIN':
            console.log("loading")
            return {...state, loadingRESERVATION: true}
        case 'GET_SJPRICEANDTAX_ERROR':
            console.log("error")
            return {...state, errorRESERVATION: true, errob:action.payload.errob,crudsuccessob:null}

        /*sva */
        case "RESET_SJPRICEANDTAX_INIT":
            let  my_data_price_confirmation_init = {
                "id":-11,
                "status":"FAILED",
                "confirmationNumber":"",
                "chekinDate":""
            }
             console.log("reduce %%%%%%%%RESET_SAVESTOREDCARD_INIT  success*****************");
                januState = {...state, errorRESERVATION:false, loadingRESERVATION:false, crudsuccessob:null, my_data_price_confirmation:my_data_price_confirmation_init}
 
        /*svae */
        /*svay21 start */
        case 'GET_SHREVIEW_MAILUSER_SJ_SUCCESS':
            console.log("reduce %%%%%%%%GET_SHREVIEW_MAILUSER_SJ_SUCCESS  success*****************");
            console.log(action.payload.my_data_review);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state, loadingRESERVATION: false, sj_data_address:action.payload.sj_data_address}
            return januState
        /*svmay21 end */
        case 'GET_SJREVIEW_SUCCESS':
            console.log("reduce %%%%%%%%GET_SJREVIEW_SUCCESS  success*****************");
            console.log(action.payload.my_data_review);
            //svjun4 start
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            //januState = {...state, loadingRESERVATION: false, my_data_review: action.payload.my_data_review}
          
            januState = {...state, loadingRESERVATION: false, my_data_geo:action.payload.my_data_geo, my_data_review: action.payload.my_data_review}
            //svjun4 end
            return januState
        case 'SJRESERVATIONS_PRIMARY_ADDRESS':
                console.log("reduce %%%%%%%%GET_SJREVIEW_SUCCESS  success*****************");
                console.log(action.payload.sj_data_address);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  sj_data_address: action.payload.sj_data_address}
                return januState
        case 'SJRESERVATIONS_PRIMARY_CONFIRMATION':
                    console.log("reduce %%%%%%%%SJRESERVATIONS_PRIMARY_CONFIRMATION  success*****************");
                    console.log(action.payload.my_data_price_confirmation);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_price_confirmation: action.payload.my_data_price_confirmation}
                    return januState

        case 'GET_SJREVIEW_MYRESERVATION_SV_SUCCESS':
                console.log("reduce %%%%%%%%GET_SJREVIEW_MYRESERVATION_SV_SUCCESS  success*****************");
                console.log(action.payload);

                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state, errob:null,crudsuccessob:null,loadingRESERVATION: false,sj_data_card:action.payload.sj_data_card, sj_data_address: action.payload.sj_data_address,custProfile:action.payload.custProfile, my_data_review: action.payload.my_data_review}
                return januState
        case 'GET_SJREVIEW_BEGIN':
                console.log("loading")
                return {...state, loadingRESERVATION: true}
        case 'GET_SJREVIEW_ERROR':
                console.log("error")
                return {...state, errorRESERVATION: true}
        case 'SAVETRAVELLER_SJREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%%SAVETRAVELLER_SJREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_traveller);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_traveller: action.payload.my_data_traveller}
                    return januState
        
        default:
            return state
    }
}